import { Button } from '@/components/ui/Button';
import { Skeleton } from '@/components/ui/Skeleton';
import { useAdminVaultDetail } from '@/hooks/useAdminVaults';
import { ArrowLeft } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { VaultStatusCard } from '../components/VaultStatusCard';
import { VaultComplianceCard } from '../components/VaultComplianceCard';

export function VaultDetailPage() {
  const { uuid } = useParams<{ uuid: string }>();
  const navigate = useNavigate();
  const { data: response, isLoading } = useAdminVaultDetail(uuid);
  const vault = (response as any)?.data ?? response;

  if (isLoading) return <div className="space-y-4"><Skeleton className="h-8 w-48" /><Skeleton className="h-64" /></div>;
  if (!vault) return <div className="py-12 text-center text-neutral-600 dark:text-neutral-400">Coffre introuvable</div>;

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <Button variant="ghost" size="sm" icon={<ArrowLeft className="h-4 w-4" />} onClick={() => navigate('/vaults')} />
        <h1 className="text-xl font-bold text-neutral-900 dark:text-neutral-100">{vault.name}</h1>
      </div>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <VaultStatusCard vault={vault} />
        <VaultComplianceCard />
      </div>
    </div>
  );
}
